module.exports = {
  // Global App actions
  INIT_SESSION: 'INIT_SESSION',
  FINISH_INIT_APP: 'FINISH_INIT_APP',
  SET_GENERAL_ERROR: 'SET_GENERAL_ERROR',
  CLEAR_GENERAL_ERROR: 'CLEAR_GENERAL_ERROR',
  START_APP_LOADING: 'START_APP_LOADING',
  STOP_APP_LOADING: 'STOP_APP_LOADING',
  CHANGE_GENERAL_CONFIRM_DIALOG: 'CHANGE_GENERAL_CONFIRM_DIALOG',

  // Init App data
  GET_META_DATA: 'GET_META_DATA',
  SET_LIST_RESTAURANT: 'SET_LIST_RESTAURANT',
  RECEIVE_LIST_TABLE_RESTAURANTS: 'RECEIVE_LIST_TABLE_RESTAURANTS',
  TABLE_META_DATA_RECEIVED: 'TABLE_META_DATA_RECEIVED',

  // Generic actions
  OPEN_DIALOG_GENERIC: 'OPEN_DIALOG_GENERIC',
  CLOSE_DIALOG_GENERIC: 'CLOSE_DIALOG_GENERIC',
  CHANGE_TABLE_PAGE_SIZE: 'CHANGE_TABLE_PAGE_SIZE',
  CHANGE_TABLE_ACTIVE_PAGE: 'CHANGE_TABLE_ACTIVE_PAGE',
  SELECT_TABLE_ITEM: 'SELECT_TABLE_ITEM',
  CHANGE_FILTER_GENERIC: 'CHANGE_FILTER_GENERIC',

  // Login
  REQUEST_LOGIN: 'REQUEST_LOGIN',
  LOGIN_SUCCESSFULLY: 'LOGIN_SUCCESSFULLY',
  GET_PROFILE_SUCCESSFULLY: 'GET_PROFILE_SUCCESSFULLY',
  GET_PROFILE_ERROR: 'GET_PROFILE_ERROR',
  CONFIRM_PASSWORD_ERROR: 'CONFIRM_PASSWORD_ERROR',
  CONFIRM_PASSWORD_SUCCESSFULLY: 'CONFIRM_PASSWORD_SUCCESSFULLY',
  CONFIRM_PASSWORD_CLEAR: 'CONFIRM_PASSWORD_CLEAR',
  SET_AUTHENTICATION: 'SET_AUTHENTICATION',
  RESET_AUTHENTICATION: 'RESET_AUTHENTICATION',
  SET_PROFILE: 'SET_PROFILE',
  EXCHANGE_ACCESS_TOKEN: 'EXCHANGE_ACCESS_TOKEN',
  EXCHANGE_ACCESS_TOKEN_EXTEND: 'EXCHANGE_ACCESS_TOKEN_EXTEND',

  // Setting
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  SET_CURRENT_RESTAURANT: 'SET_CURRENT_RESTAURANT',
  GET_CURRENT_RESTAURANT: 'GET_CURRENT_RESTAURANT',
  SET_SIDEBAR_COLLAPSE: 'SET_SIDEBAR_COLLAPSE',
  SET_RING_BELL: 'SET_RING_BELL',
  SET_NOTIFICATION_BELL: 'SET_NOTIFICATION_BELL',
  REMOVE_NOTIFICATION_BELL: 'REMOVE_NOTIFICATION_BELL',
  SET_SETTING_USER: 'SET_SETTING_USER',
  SET_VIEWED_NOTIFICATION: 'SET_VIEWED_NOTIFICATION',
  SET_RING_ALL_RESTAURANT: 'SET_RING_ALL_RESTAURANT',

  // Order
  RECEIVE_LIST_ORDER_MANAGEMENT_IDS: 'RECEIVE_LIST_ORDER_MANAGEMENT_IDS',
  RECEIVE_LIST_ORDER_MANAGEMENT_INFOS: 'RECEIVE_LIST_ORDER_MANAGEMENT_INFOS',
  RECEIVE_ORDER_DETAIL: 'RECEIVE_ORDER_DETAIL',
  CHANGE_FILTER_ORDER_MANAGEMENT: 'CHANGE_FILTER_ORDER_MANAGEMENT',
  RECEIVE_RESTAURANT_NEXT_OPEN_TIME: 'RECEIVE_RESTAURANT_NEXT_OPEN_TIME',
  SET_EDIT_DISH_OUT_OF_STOCK: 'SET_EDIT_DISH_OUT_OF_STOCK',

  // Report Dish
  RECEIVE_LIST_REPORT_DISH: 'RECEIVE_LIST_REPORT_DISH',
  CHANGE_FILTER_REPORT_DISH: 'CHANGE_FILTER_REPORT_DISH',

  // Report Restaurant
  RECEIVE_LIST_REPORT_RESTAURANT_INFO: 'RECEIVE_LIST_REPORT_RESTAURANT_INFO',
  RECEIVE_LIST_REPORT_RESTAURANT_IDS: 'RECEIVE_LIST_REPORT_RESTAURANT_IDS',
  OPEN_TRANSACTION_REPORT_RESTAURANT: 'OPEN_TRANSACTION_REPORT_RESTAURANT',
  RECEIVE_TRANSACTION_REPORT_RESTAURANT: 'RECEIVE_TRANSACTION_REPORT_RESTAURANT',
  CHANGE_TABLE_ACTIVE_PAGE_TRANSACTION: 'CHANGE_TABLE_ACTIVE_PAGE_TRANSACTION',
  CHANGE_TABLE_PAGE_SIZE_TRANSACTION: 'CHANGE_TABLE_PAGE_SIZE_TRANSACTION',
  CHANGE_FILTER_TRANSACTION: 'CHANGE_FILTER_TRANSACTION',

  // Now Ship General action
  RECEIVE_INIT_DATA_NOW_SHIP: 'RECEIVE_INIT_DATA_NOW_SHIP',
  CHANGE_CURRENT_RESTAURANT_NOW_SHIP: 'CHANGE_CURRENT_RESTAURANT_NOW_SHIP',

  // Now Ship Order Management actions
  RECEIVE_ORDER_MANAGEMENT_LIST_NOW_SHIP:
    'RECEIVE_ORDER_MANAGEMENT_LIST_NOW_SHIP',
  CHANGE_ORDER_STATUS_NOW_SHIP: 'CHANGE_ORDER_STATUS_NOW_SHIP',
  OPEN_DIALOG_CANCELED_REASON: 'OPEN_DIALOG_CANCELED_REASON',
  CLOSE_DIALOG_CANCELED_REASON: 'CLOSE_DIALOG_CANCELED_REASON',
  // Now Ship Booking Order actions
  RESET_STATE_BOOKING_NOW_SHIP: 'RESET_STATE_BOOKING_NOW_SHIP',
  CHANGE_MULTI_INPUT_BOOKING_NOW_SHIP: 'CHANGE_MULTI_INPUT_BOOKING_NOW_SHIP',
  CHANGE_INPUT_BOOKING_NOW_SHIP: 'CHANGE_INPUT_BOOKING_NOW_SHIP',
  CHANGE_DATA_BOOKING_NOW_SHIP: 'CHANGE_DATA_BOOKING_NOW_SHIP',
  RECEIVE_SHIPPER_ON_MAP_BOOKING_NOW_SHIP:
    'RECEIVE_SHIPPER_ON_MAP_BOOKING_NOW_SHIP',
  RECEIVE_LOCATION_INFO_BOOKING_NOW_SHIP:
    'RECEIVE_LOCATION_INFO_BOOKING_NOW_SHIP',
  RECEIVE_DATA_REPORT_NOW_SHIP: 'RECEIVE_DATA_REPORT_NOW_SHIP',
  RECEIVE_COMMISSION_FEE_NOW_SHIP: 'RECEIVE_COMMISSION_FEE_NOW_SHIP',
  // Wallet
  RECEIVE_LIST_USER_WALLET: 'RECEIVE_LIST_USER_WALLET',
  RECEIVE_USER_WALLET_RESTAURANT: 'RECEIVE_USER_WALLET_RESTAURANT',
  CLOSE_USER_WALLET_RESTAURANT_MODAL: 'CLOSE_USER_WALLET_RESTAURANT_MODAL',
  OPEN_CREATE_USER_WALLET_MODAL: 'OPEN_CREATE_USER_WALLET_MODAL',
  OPEN_UPDATE_USER_WALLET_MODAL: 'OPEN_UPDATE_USER_WALLET_MODAL',
  OPEN_ADD_RESTAURANT_USER_WALLET_MODAL:
    'OPEN_ADD_RESTAURANT_USER_WALLET_MODAL',
  CLOSE_ADD_RESTAURANT_USER_WALLET: 'CLOSE_ADD_RESTAURANT_USER_WALLET',
  RECEIVE_LIST_UNLINKED_RESTAURANT: 'RECEIVE_LIST_UNLINKED_RESTAURANT',
  SET_TOGGLE_OPEN_ACTIVE_EMAIL_MODAL: 'SET_TOGGLE_OPEN_ACTIVE_EMAIL_MODAL',
  CHANGE_TABLE_ACTIVE_PAGE_WALLET_RESTAURANT:
    'CHANGE_TABLE_ACTIVE_PAGE_WALLET_RESTAURANT',
  CHANGE_TABLE_PAGE_SIZE_WALLET_RESTAURANT:
    'CHANGE_TABLE_PAGE_SIZE_WALLET_RESTAURANT',

  // TABLE NOW
  RECEIVE_LIST_TABLE_MANAGEMENT_IDS: 'RECEIVE_LIST_TABLE_MANAGEMENT_IDS',
  RECEIVE_LIST_TABLE_MANAGEMENT_INFOS: 'RECEIVE_LIST_TABLE_MANAGEMENT_INFOS',
  CHANGE_ORDER_TABLE_ITEM: 'CHANGE_ORDER_TABLE_ITEM',
  RECEIVE_EXTENDED_TABLE_MANAGEMENT_INFOS:
    'RECEIVE_EXTENDED_TABLE_MANAGEMENT_INFOS',

  // NOW PORTAL
  RECEIVE_NOW_PORTAL_META_DATA: 'RECEIVE_NOW_PORTAL_META_DATA',
  RECEIVE_ORDER_MANAGEMENT_LIST_NOW_PORTAL:
    'RECEIVE_ORDER_MANAGEMENT_LIST_NOW_PORTAL',
  RECEIVE_LIST_STORE_NOW_PORTAL: 'RECEIVE_LIST_STORE_NOW_PORTAL',
  RECEIVE_PROFILE_NOW_PORTAL: 'RECEIVE_PROFILE_NOW_PORTAL',
  RECEIVE_BANK_ACCOUNT_NOW_PORTAL: 'RECEIVE_BANK_ACCOUNT_NOW_PORTAL',
  RECEIVE_BALANCE_NOW_PORTAL: 'RECEIVE_BALANCE_NOW_PORTAL',
  RECEIVE_LIST_BANK_NOW_PORTAL: 'RECEIVE_LIST_BANK_NOW_PORTAL',
  RECEIVE_BANK_TRANSFER_NOW_PORTAL: 'RECEIVE_BANK_TRANSFER_NOW_PORTAL',

  // Export Restaurant
  RECEIVE_LIST_EXPORT_RESTAURANT: 'RECEIVE_LIST_EXPORT_RESTAURANT',
  RECEIVE_ITEM_EXPORT_RESTAURANT: 'RECEIVE_ITEM_EXPORT_RESTAURANT',

  // Setting Staff
  RECEIVE_LIST_STAFF: 'RECEIVE_LIST_STAFF',
  OPEN_CREATE_STAFF_MODAL: 'OPEN_CREATE_STAFF_MODAL',

  // Chat Box actions
  OPEN_CHAT_CHANNEL: 'OPEN_CHAT_CHANNEL',
  CLOSE_CHAT_CHANNEL: 'CLOSE_CHAT_CHANNEL',
  MINIFY_CHAT_CHANNEL: 'MINIFY_CHAT_CHANNEL',
  FOCUS_CHAT_CHANNEL_INPUT: 'FOCUS_CHAT_CHANNEL_INPUT',
  BLUR_CHAT_CHANNEL_INPUT: 'BLUR_CHAT_CHANNEL_INPUT',
  CHANGE_DRAFT_MESSAGE: 'CHANGE_DRAFT_MESSAGE',
  SELECT_CHAT_CHANNEL: 'SELECT_CHAT_CHANNEL',
  SELECT_CHAT_TAB: 'SELECT_CHAT_TAB',
  START_LOADING_MESSAGE: 'START_LOADING_MESSAGE',
  STOP_LOADING_MESSAGE: 'STOP_LOADING_MESSAGE',
  SEND_MESSAGE_SUCCESS: 'SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_FAIL: 'SEND_MESSAGE_FAIL',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  EDIT_MESSAGE: 'EDIT_MESSAGE',
  UPDATE_USER_SEEN_STATUS: 'UPDATE_USER_SEEN_STATUS',
  RECEIVE_MESSAGE_LIST: 'RECEIVE_MESSAGE_LIST',
  RECEIVE_NEW_MESSAGE: 'RECEIVE_NEW_MESSAGE',
  CLEAR_UNREAD_MESSAGE: 'CLEAR_UNREAD_MESSAGE',
  INIT_CHAT_CHANNEL: 'INIT_CHAT_CHANNEL',

  // Transfer order
  START_TRANSFERRING_ORDER: 'START_TRANSFERRING_ORDER',
  STOP_TRANSFERRING_ORDER: 'STOP_TRANSFERRING_ORDER',
  TRANSFERRED_BRANCH_SELECTED: 'TRANSFERRED_BRANCH_SELECTED',
  GO_TO_VERIFYING_STEP: 'GO_TO_VERIFYING_STEP',
  ATTEMPT_CHANGE_RESTAURANT_SUCCESSFULLY: 'ATTEMPT_CHANGE_RESTAURANT_SUCCESSFULLY',
  ATTEMPT_CHANGE_RESTAURANT_FAILED: 'ATTEMPT_CHANGE_RESTAURANT_FAILED',
  CHANGE_RESTAURANT_FAILED: 'CHANGE_RESTAURANT_FAILED',
};



// WEBPACK FOOTER //
// ./foody/src/constants/actionTypes.js